// this file added for individual by Bearer Web Developer
import React from "react";
import { Button } from "@mui/material";
import { Observer, observer } from "mobx-react-lite";
import styles from './request.module.scss'; // added by Bearer Web Developer
import RightRadioButton from "../../../components/rightradiobutton/RightRadioButton";
import { useAppState } from "../../../states/app-state";
import { ReasonForDeleteAccountEnum, StepForDeleteAccountEnum } from "../../../states/deleteAccountState";
import { toJS } from "mobx";
import { analytics } from "../../../api/bearer-api";
import { logEvent } from "firebase/analytics";

const RequestDeleteAccount: React.FC = observer(() => {

    const appState = useAppState();
    const { deleteAccount } = appState;
    const { setLoading } = deleteAccount;
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const valid = !!deleteAccount.reason
        if (valid) {
            console.log(toJS(deleteAccount));
            try {
                setLoading(true);
                if (deleteAccount.reason) {
                    const result = await deleteAccount.customerRequestDeleteAccount();
                    setLoading(false);
                    if (result) deleteAccount.setStep(StepForDeleteAccountEnum.Confirm);
                }

            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        }
    }
    const handleClose = () => {
        deleteAccount.setOpen(false);
    }
    // modified by Bearer Web Developer start
    return (
        <section className={styles.request_delete_acount}>
            <header className={styles.header}>
                <h3>Delete Account</h3>
                <Button className={styles.cancel} disableRipple={true} onClick={handleClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M9.79992 19.833L13.9999 15.633L18.1999 19.833L19.8333 18.1997L15.6333 13.9997L19.8333 9.79967L18.1999 8.16634L13.9999 12.3663L9.79992 8.16634L8.16659 9.79967L12.3666 13.9997L8.16659 18.1997L9.79992 19.833ZM13.9999 25.6663C12.386 25.6663 10.8694 25.3601 9.44992 24.7476C8.03047 24.1351 6.79575 23.3038 5.74575 22.2538C4.69575 21.2038 3.8645 19.9691 3.252 18.5497C2.6395 17.1302 2.33325 15.6136 2.33325 13.9997C2.33325 12.3858 2.6395 10.8691 3.252 9.44967C3.8645 8.03023 4.69575 6.79551 5.74575 5.74551C6.79575 4.69551 8.03047 3.86426 9.44992 3.25176C10.8694 2.63926 12.386 2.33301 13.9999 2.33301C15.6138 2.33301 17.1305 2.63926 18.5499 3.25176C19.9694 3.86426 21.2041 4.69551 22.2541 5.74551C23.3041 6.79551 24.1353 8.03023 24.7478 9.44967C25.3603 10.8691 25.6666 12.3858 25.6666 13.9997C25.6666 15.6136 25.3603 17.1302 24.7478 18.5497C24.1353 19.9691 23.3041 21.2038 22.2541 22.2538C21.2041 23.3038 19.9694 24.1351 18.5499 24.7476C17.1305 25.3601 15.6138 25.6663 13.9999 25.6663ZM13.9999 23.333C16.6055 23.333 18.8124 22.4288 20.6208 20.6205C22.4291 18.8122 23.3333 16.6052 23.3333 13.9997C23.3333 11.3941 22.4291 9.18717 20.6208 7.37884C18.8124 5.57051 16.6055 4.66634 13.9999 4.66634C11.3944 4.66634 9.18742 5.57051 7.37909 7.37884C5.57075 9.18717 4.66659 11.3941 4.66659 13.9997C4.66659 16.6052 5.57075 18.8122 7.37909 20.6205C9.18742 22.4288 11.3944 23.333 13.9999 23.333Z" fill="#858585" />
                    </svg>
                </Button>
            </header>
            <p className={styles.read}>Please read text bellow</p>
            <p className={styles.description}>
                By deleting your account, your account will be removed permanently and your data will be unrecoverable.
                <br />
                If you are experiencing any issue with your account, pleas give us the opportunity to help you. and if not we are truly sorry to see you leave.
            </p>
            <p className={styles.share}>Please share your reason with us to help us improve:</p>
            <form onSubmit={handleSubmit}>
                <section className={styles.reasons}>
                    <RightRadioButton
                        label={ReasonForDeleteAccountEnum.TooHighCost}
                        value={ReasonForDeleteAccountEnum.TooHighCost}
                        checked={deleteAccount.reason === ReasonForDeleteAccountEnum.TooHighCost}
                        onClick={() => {
                            deleteAccount.setReason(ReasonForDeleteAccountEnum.TooHighCost);
                        }}
                        gray={true}
                    />
                    <RightRadioButton
                        label={ReasonForDeleteAccountEnum.NotFitToTheJobs}
                        value={ReasonForDeleteAccountEnum.NotFitToTheJobs}
                        checked={deleteAccount.reason === ReasonForDeleteAccountEnum.NotFitToTheJobs}
                        onClick={() => {
                            deleteAccount.setReason(ReasonForDeleteAccountEnum.NotFitToTheJobs);
                        }}
                        gray={true}
                    />
                    <RightRadioButton
                        label={ReasonForDeleteAccountEnum.DelaysCompleted}
                        value={ReasonForDeleteAccountEnum.DelaysCompleted}
                        checked={deleteAccount.reason === ReasonForDeleteAccountEnum.DelaysCompleted}
                        onClick={() => {
                            deleteAccount.setReason(ReasonForDeleteAccountEnum.DelaysCompleted);
                        }}
                        gray={true}
                    />
                    <RightRadioButton
                        label={ReasonForDeleteAccountEnum.Others}
                        value={ReasonForDeleteAccountEnum.Others}
                        checked={deleteAccount.reason === ReasonForDeleteAccountEnum.Others}
                        onClick={() => {
                            deleteAccount.setReason(ReasonForDeleteAccountEnum.Others);
                        }}
                        gray={true}
                    />
                </section>
                <Observer>{() => {
                    const valid = !!deleteAccount.reason
                    return (
                        <Button className={styles.submit} disabled={!valid} type='submit' disableRipple={true}>
                            Submit
                        </Button>
                    )
                }}</Observer>
            </form>
        </section>
    );
    // modified by Bearer Web Developer end
})
export default RequestDeleteAccount;